import React from "react";

export const MOVEMENT_TYPE_META = {
    SALE: { label: 'Venta', bg: 'success' },
    COURTESY: { label: 'Cortesía', bg: 'info' },
    WASTE: { label: 'Merma', bg: 'danger' },
    PROMOTION: { label: 'Promoción', bg: 'warning', text: 'dark' },
    TASTING: { label: 'Degustación', bg: 'secondary' },
    RECEIPT: { label: 'Entrada', bg: 'primary' },
    PROCESS_CONVERSION: { label: 'Conversión de proceso', bg: 'warning', text: 'dark' },
    PROCESS_FINISH: { label: 'Finalización de proceso', bg: 'secondary' },
    ADJUST: { label: 'Ajuste', bg: 'dark' },
    UNDO: { label: 'Reversa', bg: 'dark' },
};

export const getMovementTypeMeta = (type) =>
    MOVEMENT_TYPE_META[String(type || '').trim().toUpperCase()] || null;